import React, { useState } from "react";
import html2canvas from "html2canvas";
import { ReactComponent as CameraIcon } from "../../icons/camera.svg";
import styles from "./ScreenshotButton.module.scss";
import { Tooltip } from "react-tooltip";
import classNames from "classnames";

const ScreenshotButton = () => {
  const [isCapturing, setIsCapturing] = useState(false);

  const handleScreenshot = async () => {
    setIsCapturing(true);

    const elementsToHide = [
      document.querySelector("[class*='floatingBarContainer']"),
      document.querySelector("[data-screenshot-icon='true']"),
    ];

    elementsToHide.forEach((el) => {
      if (el) el.style.display = "none";
    });

    await new Promise((res) => setTimeout(res, 100));

    const originalCanvas = await html2canvas(document.body);

    // CROP: exclude first 80px
    const croppedCanvas = document.createElement("canvas");
    const cropHeight = originalCanvas.height - 80;

    croppedCanvas.width = originalCanvas.width;
    croppedCanvas.height = cropHeight;

    const ctx = croppedCanvas.getContext("2d");
    ctx.drawImage(
      originalCanvas,
      0,
      70, // start at y = 70
      originalCanvas.width,
      cropHeight,
      0,
      0,
      originalCanvas.width,
      cropHeight,
    );

    // Download cropped image
    const now = new Date();
    const filename = `Borderly+ Screenshot ${now.toISOString().slice(0, 19).replace(/[:T]/g, "-")}.png`;

    const link = document.createElement("a");
    link.download = filename;
    link.href = croppedCanvas.toDataURL("image/png");
    link.click();

    // Restore UI
    elementsToHide.forEach((el) => {
      if (el) el.style.display = "";
    });

    setIsCapturing(false);
  };

  return (
    <>
      <button
        className={classNames(styles.screenshotButton, {
          [styles.hidden]: isCapturing,
        })}
        onClick={handleScreenshot}
        data-screenshot-icon={true}
        data-tooltip-id="screenshot-tooltip"
        data-tooltip-content="Download screenshot"
        aria-label="Download screenshot"
      >
        <CameraIcon />
      </button>
      <Tooltip id="screenshot-tooltip" className={styles.tooltip} />
    </>
  );
};

export default ScreenshotButton;
